"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToIsoWeek = dateToIsoWeek;
/**
 * Formats a date as its ISO-8601 week string, `YYYY-Www` (e.g. "2026-W26").
 *
 * Weeks are Monday-based and week 1 is the week containing the year's first
 * Thursday (ISO-8601). The date's calendar day is read and the computation is
 * carried out in UTC, so the result only depends on the calendar day, never on
 * the host timezone. Shared by the web planning view (week navigation) and the
 * API (building deep-links into the right week).
 *
 * @param date - the date whose ISO week is wanted
 * @returns the ISO week string `YYYY-Www`
 */
function dateToIsoWeek(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}
